import React from 'react'

import { CoinStore } from '../stores/CoinStore'

export default class WatchList extends React.Component {
  state = {
    currencies: {},
    filter: '', // value entered in the search box
    favorites: {}, // symbols mapped to boolean
    showOnlyFavs: false,
  }

  componentDidMount() {
    var initialState = {currencies: CoinStore.currencies}

    if (localStorage.getItem('watchlist')) {
      initialState.favorites = JSON.parse(localStorage.getItem('watchlist'))
    }
    if (localStorage.getItem('watchlist_favs')) {
      initialState.showOnlyFavs = (localStorage.getItem('watchlist_favs') === 'true')
    }

    this.handler = CoinStore.on('data', currencies => {
      this.setState({ currencies: CoinStore.currencies })
    })

    if (this.searchInput) this.searchInput.focus()

    this.setState(initialState)
  }

  componentWillUnmount() {
    CoinStore.removeListener('data', this.handler)
  }

  toggleShowFavs = (e) => {
    this.setState({showOnlyFavs: e.target.checked})
    localStorage.setItem('watchlist_favs', e.target.checked)
  }

  toggleFavorite = (c) => {
    var favs = this.state.favorites
    if (favs[c.symbol]) {
      delete favs[c.symbol]
    } else {
      favs[c.symbol] = true
    }
    this.setState({favorites: favs})

    localStorage.setItem('watchlist', JSON.stringify(favs))
  }

  isFavorite = (c) => {
    return this.state.favorites[c.symbol] === true
  }

  prettify(symbol) {
    const [a, b] = symbol.split('_')
    return b + a
  }

  formatPercentage(p) {
    var num = Number(p) * 100
    if (num >= 0) {
      return '+' + num.toFixed(2)
    } else {
      return num.toFixed(2)
    }
  }

  formatVolume(v) {
    return Number(v).toFixed(2)
  }

  row = (c) => {
    var favClass = 'f5 inline-flex items-center pv2 ph3 mr3'
    if (this.isFavorite(c)) {
      favClass += ' fav-on'
    } else {
      favClass += ' fav-off'
    }
    return (
      <li key={c.symbol} className='flex items-center lh-copy pa1 bb'>
        <div className="w3 f5">
          <a className={favClass} href="#watchlist"
            onClick={() => this.toggleFavorite(c)}>
            <svg height="25" width="23">
              <polygon points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78" />
            </svg>
          </a>
        </div>
        <div className="w5 f5">
          {this.prettify(c.symbol)}
        </div>
        <div className="w5 f5">
          {c.last}
        </div>
        <div className="w5 f5">
          {this.formatPercentage(c.percentChange)}
        </div>
        <div className="w5 f5 dn db-ns">
          {this.formatVolume(c.baseVolume)}
        </div>
      </li>
    )
  }

  listHeader() {
    return (
      <li key='header' className='flex items-center lh-copy pa2 bb'>
        <div className="w3 f5">
          <span className="f5 inline-flex items-center pv2 ph3 mr2">
            <svg height="25" width="23">
              <polygon points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78" />
            </svg>
          </span>
        </div>
        <div className="w5 f5">
          Symbol
        </div>
        <div className="w5 f5">
          Price
        </div>
        <div className="w5 f5">
          % Change
        </div>
        <div className="w5 f5 dn db-ns">
          Volume
        </div>
      </li>
    )
  }

  list = (coins) => {
  	return (
  		<ul className='list pl0 ma0 b--light-silver br2'>
        { this.listHeader() }
  			{coins.map(c => {
          return this.row(c)
        })}
  		</ul>
  	)
  }

  filter = (e) => {
    var text = e.target.value.toUpperCase()
    this.setState({filter: text})
  }

  render() {
    let {filter, showOnlyFavs, favorites} = this.state

    var currencies = this.state.currencies

    if (showOnlyFavs === true) {
      currencies = Object.keys(currencies).reduce(function(acc, symbol) {
        if (favorites[symbol] === true) {
          var c = CoinStore.currencies[symbol]
          if (c) {
            acc[symbol] = c
          }
        }
        return acc
      }, {})
      // note we keep currencies an object
    }

    if (filter) {
      currencies = Object.keys(currencies).reduce((acc, symbol) => {
        const prettified = this.prettify(symbol)
        if (prettified.startsWith(filter)) {
          var c = CoinStore.currencies[symbol]
          if (c) {
            c.symbol = symbol
            acc.push(c)
          }
        }
        return acc
      }, [])
    } else {
      currencies = Object.keys(currencies).reduce(function(acc, symbol) {
        var c = CoinStore.currencies[symbol]
        if (c) {
          c.symbol = symbol
          acc.push(c)
        }
        return acc
      }, [])
    }
    // after filter we get an array

    return (
      <div className='pa2'>
        <nav className="w-100">
          <div className="overflow-x-auto">
            <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
            href="#charts"
            onClick={this.props.onCancel}>Charts</a>
          </div>
        </nav>
        <div className='w-100 pa2'>
          <input ref={(input) => { this.searchInput = input; }}
            onChange={this.filter}
            className="input-reset ba b--black-20 pa2 mb2 dib w-100" type="text" />
        </div>
        <div className='w-100 pb2 pl2'>
          <label className="dib" htmlFor="showFavs">
            <input id="showFavs" name="showFavs" type="checkbox"
              checked={this.state.showOnlyFavs} onChange={this.toggleShowFavs} />
            {' Only Favorites'}
          </label>
        </div>
        <div className='h-75 overflow-y-auto'>
          { this.list(currencies) }
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/WatchList.js